import React from 'react';
interface CTAButtonProps {
  text?: string;
  href?: string;
  className?: string;
}
export function CTAButton({
  text = '→ LO QUIERO AHORA',
  href = '#precio-lanzamiento',
  className = ''
}: CTAButtonProps) {
  return <a href={href} className={`inline-flex items-center justify-center bg-cta hover:bg-cta-hover text-black font-bold text-lg md:text-xl py-4 px-8 rounded-lg transition-all duration-300 shadow-cta hover:shadow-cta-hover transform hover:-translate-y-1 ${className}`} data-id="element-8">
      {text}
    </a>;
}